import { ToolGroup } from "./components/ToolGroup";
import { ISupportedTopLevelComponent } from "./types";

/**
 * Set of supported top level components 
 */
 export const supportedTopLevelComponentTypes : ISupportedTopLevelComponent[] = [
    ToolGroup
];